<template>
  <v-layout>
    <v-flex>
      <text-field
        v-model.trim="form.name"
        :rules="vs.form.name"
        label="Referral name"
        autofocus
      />
    </v-flex>
  </v-layout>
</template>

<script>

export default {
  name: 'referral-form',
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: this.initialValues,
    }
  },
}
</script>

<style scoped>
</style>
